import { Component } from 'react';
import { Redirect } from 'react-router-dom';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError && process.env.NODE_ENV === 'production') {
      console.log('has error', this.state.hasError);
      window.location.href = '/404';
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
